import React, { memo, useState } from 'react';
import classNames from 'classnames';
import Button from '@ratedpeople/button';
import style from './style.module.scss';
var defaultProps = {
  tooltipText: '',
  tooltipHideMobile: false,
  tooltipHideDesktop: false,
  alwaysArrowTop: false
};

var Tooltip = function Tooltip(_ref) {
  var _classNames, _classNames2, _classNames3;

  var tooltipText = _ref.tooltipText,
      tooltipClose = _ref.tooltipClose,
      alwaysArrowTop = _ref.alwaysArrowTop,
      tooltipHideMobile = _ref.tooltipHideMobile,
      tooltipHideDesktop = _ref.tooltipHideDesktop,
      expandedinfo = _ref.expandedinfo;

  var _useState = useState(false),
      infoShown = _useState[0],
      setInfoShown = _useState[1];

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(style['tooltip'], (_classNames = {}, _classNames[style['top-arrow']] = alwaysArrowTop, _classNames), (_classNames2 = {}, _classNames2[style['hide-mobile']] = tooltipHideMobile, _classNames2), (_classNames3 = {}, _classNames3[style['hide-desktop']] = tooltipHideDesktop, _classNames3))
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon']
  }), /*#__PURE__*/React.createElement("div", {
    className: style['text']
  }, tooltipText), expandedinfo && /*#__PURE__*/React.createElement(Button, {
    theme: "secondary",
    className: style['more-tip-container'],
    size: "small",
    name: "more-tips-button",
    onClick: function onClick() {
      return setInfoShown(true);
    }
  }, "See more tips"), infoShown && /*#__PURE__*/React.createElement("div", {
    className: style['info-screen-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info-container']
  }, expandedinfo, /*#__PURE__*/React.createElement("button", {
    className: style['more-info-button-close'],
    onClick: function onClick() {
      return setInfoShown(false);
    }
  }))));
};

Tooltip.defaultProps = defaultProps;
export default /*#__PURE__*/memo(Tooltip);